export class DateOptionModel {
  day: number | null;
  month: number;
  year: number;
}
